<template>
  <div>
    <div class="text-disabled mb-4">
      Система аналізує всі подачі інформації щодо боржника до Кредитного реєстру
      за ідентифікатором і відображає повну історію за весь період використання
      системи: коли подавалися дані, які активи (забезпечення) було припинено та
      які залишаються діючими.
    </div>

    <div class="d-flex align-center ga-2 flex-wrap mb-5">
      <span class="text-disabled">Результат за ідентифікатором:</span>
      <span class="id-badge">{{ debtorChronology.data.debtorId }}</span>
    </div>

    <debtor-chronology-report
      v-if="debtorChronology.data.packagesCount"
      :debtor-chronology="debtorChronology"></debtor-chronology-report>
    <div v-else class="text-center text-disabled">
      Боржник з таким ідентифікатором не подавався до кредитного реєстру
    </div>
  </div>
</template>

<script lang="ts">
import { computed, PropType } from 'vue'
import { Dialog } from 'best-modules/plugins'
import type { DebtorChronology } from '@/utils/types'
import DebtorChronologyReport from '@/pages/report-printed-form/result/debtor-chronology/DebtorChronologyReport.vue'

export default {
  name: 'DebtorChronologyView',
  components: { DebtorChronologyReport },
  props: {
    dialog: {
      type: Object as PropType<Dialog<'DebtorChronologyView'>>,
      required: true,
    },
  },
  setup(props) {
    const debtorChronology = computed<DebtorChronology>(() => {
      return props.dialog.dialogData.debtorChronology
    })

    return { debtorChronology }
  },
}
</script>

<style scoped lang="scss">
.id-badge {
  font-family: monospace;
  font-size: 13px;
  background-color: rgba(var(--v-theme-on-surface), 0.06);
  border-radius: 6px;
  padding: 2px 8px;
}
</style>
